// extracted by mini-css-extract-plugin
module.exports = {"instructionGroup":"Instruction_instructionGroup__hlMho","instructionContainer":"Instruction_instructionContainer__N_lnm","iconContainer":"Instruction_iconContainer___tXd0"};